import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}><path d="M403.2 300.8H268.8v134.4c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8V300.8H44.8C20.1 300.8 0 280.7 0 256s20.1-44.8 44.8-44.8h134.4V76.8c0-24.7 20.1-44.8 44.8-44.8s44.8 20.1 44.8 44.8v134.4h134.4c24.7 0 44.8 20.1 44.8 44.8s-20.1 44.8-44.8 44.8z" fill="#fff" /></svg>);